import { render, staticRenderFns } from "./ModuleEmployee.vue?vue&type=template&id=5e4a6b28&"
import script from "./ModuleEmployee.vue?vue&type=script&lang=js&"
export * from "./ModuleEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports